import type { FC } from 'react'
import { ThreadStatusBannerView } from '@/components/agent/ThreadStatusBannerView'
import { useThreadStatus } from './ThreadStatusContext'

/** Connects {@link ThreadStatusBannerView} to the thread-status context. */
export const ThreadStatusBanner: FC = () => {
  const { status, dismiss, startNewThread } = useThreadStatus()
  return (
    <ThreadStatusBannerView status={status} onDismiss={dismiss} onStartNewThread={startNewThread} />
  )
}
